<template>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import router from '../../router/router';
import { ApiPath } from '../../fetch/config';
import Container from '../../utils/container.js';
import {randomLetNum } from '../../utils/utils';
import Assert from '../../utils/assert';
import Auth from '../../utils/auth';
import SiteEnv from '../../utils/siteEnv';

const wxAppid = SiteEnv.showWxServerAccountAppid();

export default {
  name: 'Login',
  meta:{page:true},
  computed: {
        ...mapGetters('user', {
            loginConfig: 'getLoginConfig',
            loginStatus: 'login'
        })
  },
  data() {
    return {
        userName: '',
        password: '',
        showError: false,
        showPasswordError: false,
    }
  },
    created() {
        this.dispatchLogin();
  },
  methods: {
      dispatchLogin(){
          let action = this.$route.params.action;
            switch(action){
                case  'wxEnd' :
                   // this.$store.dispatch('user/loginInit');
                    return this.wxEnd();
                case  'begin' :
                   // this.$store.dispatch('user/loginInit');
                    return this.begin();
                case  'end' :
                   // this.$store.dispatch('user/loginInit');
                    let refer = this.$route.query.refer;
                    return router.replace(refer || '/');
                case  'logout' :
                    return this.logout();
                default:
                //TODO 断言无法处理
                break;
            }

        },

        end(){
                return this.wxEnd();
                //TODO 根据用户的登录设备决定去哪里结果授权
        },

        begin(){
            let refer = this.$route.query.refer||'/';
            if(Auth.loginUser()){
                router.replace('/');
            }
            //TODO 根据用户的登录设备决定去哪里开始授权
            if(Container.feature('weixin')){
                this.wxBegin();
            }else{
                router.replace({name:'loginPasswd',query:{refer:refer}});
            }
        },

        wxBegin(){
            let endLoginUrl = location.origin + '/login/wxEnd';
            let refer = this.$route.query.refer || '/';
            refer = encodeURIComponent(refer);
            endLoginUrl += `?refer=${refer}`;
            const  serverWxWebAuthDomain = SiteEnv.showServerWxWebAuthDomain();
            // study-dev.aquke.com
            // open.weixin.qq.com
            //关于网页授权的两种scope的区别说明
            //1、以snsapi_base为scope发起的网页授权，是用来获取进入页面的用户的openid的，并且是静默授权并自动跳转到回调页的。用户感知的就是直接进入了回调页（往往是业务页面）
            //2、以snsapi_userinfo为scope发起的网页授权，是用来获取用户的基本信息的。但这种授权需要用户手动同意，并且由于用户同意过，所以无须关注，就可在授权后获取该用户的基本信息。


            var openIdAuthUrl = `https://${
                serverWxWebAuthDomain
            }/connect/oauth2/authorize?appid=${
                wxAppid
            }&redirect_uri=${
                encodeURIComponent(endLoginUrl)
            }&response_type=code&scope=snsapi_userinfo&state=${
                randomLetNum(10)
            }#wechat_redirect`;
            location.href = openIdAuthUrl;
        },


        wxEnd() {
            var wxCode = this.$route.query.code;
            var referPath = this.$route.query.refer||'/';
            //loginBy   loginType从本地读出来
            axios.post(ApiPath + "/auth/login/weixin/code" + `?appid=${wxAppid}&code=${wxCode}&appType=server`).then((resp) => {
                let token = resp.data.token;
                //这里断言，让下面的catch统一处理
                //Assert.status(resp.data&&resp.data.token,"没有得到token");
                if(Auth.saveToken(token) ){
                    router.replace({path:referPath});
                }else{
                    console.log('登录失败');
                    router.replace({path:referPath,query:{failLogin:true}});
                }
            }).catch(function(err){
                console.log(err);
                router.replace({path:referPath,query:{failLogin:true}});
            });

            //TODO 删除上一个历史 有时间要找一个清除微信链接记录的方法。
            //重定向时候替换了这个原来的地址，这样，登录相关就不在历史里面了
        },
        logout() {
            //this.
            Auth.clearToken();
            let refer = this.$route.query.refer||'/';
            router.replace({path:refer});
        }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/page/Login.vue